import { z } from "zod";
import isMobilePhone from "../../../../utils/validators";

export const notificationsFormSchema = z
  .object({
    form: z.any(),
    details: z.object({
      notifications: z.array(
        z.object({
          email: z.string().email().or(z.literal("")),
          sms: z
            .string()
            .refine(isMobilePhone, "Please enter a valid phone number")
            .or(z.literal("")),
          voice: z
            .string()
            .refine(isMobilePhone, "Please enter a valid phone number")
            .or(z.literal("")),
        }),
      ),
    }),
  })
  .partial()
  .superRefine((data, ctx) => {
    if (
      !data.details?.notifications[0].email &&
      !data.details?.notifications[0].sms &&
      !data.details?.notifications[0].voice
    ) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["form"],
        message:
          "You have to have at least one of the notification preferences set.",
      });
    }
  });

export const referralFormSchema = z
  .object({
    form: z.any(),
    details: z.object({
      referral: z.object({
        phone: z
          .string()
          .refine(isMobilePhone, "Please enter a valid phone number")
          .optional()
          .or(z.literal("")),
        email: z.string().email().or(z.literal("")),
      }),
    }),
  })
  .partial()
  .superRefine((data, ctx) => {
    if (!data.details?.referral?.phone && !data.details?.referral.email) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["form"],
        message: "You have to have at least on of the contact preferences set.",
      });
    }
  });

export const settingsFormSchema = z
  .object({
    form: z.any(),
    details: z.object({
      notifications: z.array(
        z.object({
          email: z.string().email().or(z.literal("")),
          sms: z
            .string()
            .refine(isMobilePhone, "Please enter a valid phone number")
            .or(z.literal("")),
          voice: z
            .string()
            .refine(isMobilePhone, "Please enter a valid phone number")
            .or(z.literal("")),
        }),
      ),
      referral: z.object({
        phone: z
          .string()
          .refine(isMobilePhone, "Please enter a valid phone number")
          .optional()
          .or(z.literal("")),
        email: z.string().email().or(z.literal("")),
      }),
    }),
  })
  .partial()
  .superRefine((data, ctx) => {
    if (
      !data.details?.notifications[0].email &&
      !data.details?.notifications[0].sms &&
      !data.details?.notifications[0].voice
    ) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["form"],
        message:
          "You have to have at least on of the notification preferences set.",
      });
    }
  })
  .superRefine((data, ctx) => {
    if (!data.details?.referral?.phone && !data.details?.referral.email) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["form"],
        message: "You have to have at least on of the contact preferences set.",
      });
    }
  });
